<template>
    <BaseCard>
        <template #header>
            <LaCsvDownload
                :csv-data="domains.length > 1 ? multiWebsiteCsvRows : yieldData"
                :filename="filename"
                :leading-column="domains.length > 1 ? 'date' : 'website'"
            />
        </template>
        <template v-if="!yieldLoading">
            <div class="columns">
                <div class="column">
                    <RevenueImpressionsChart
                        :earnings-data="yieldData"
                        v-if="domains.length == 1 && yieldMetadata['use_slot_data'] == false"
                    />

                    <template v-if="domains.length == 1 && yieldMetadata['use_slot_data'] == true">
                        <RevenueBySlotsChart :earnings-data="yieldData" />
                        <impressionsBySlotsChart :earnings-data="yieldData" />
                    </template>

                    <WebsRevenueStackedBarChart
                        v-if="domains.length > 1 && yieldData.length"
                        :earnings-csv-data="yieldData"
                    />
                    <WebsImpressionsStackedBarChart
                        v-if="domains.length > 1 && yieldData.length"
                        :earnings-csv-data="yieldData"
                    />
                </div>
            </div>

            <div style="margin-top: 2rem">
                <LaYieldTable :data="domains.length > 1 ? yieldCsvData : yieldData" :domains-length="domains.length" />
            </div>

            <LaDialog name="dailyDataForm">
                <LaDailyDataForm />
            </LaDialog>
        </template>
        <LaDataCardLoader
            v-else
            :chart-count="domains.length > 1 || yieldMetadata?.['use_slot_data'] ? 2 : 1"
            :chart-height="domains.length > 1 ? 500 : 350"
        />
    </BaseCard>
</template>

<script>
import BaseCard from "@/components/BaseCard";
import LaDataCardLoader from "@/components/loaders/DataCardLoader";
import LaYieldTable from "@/components/yield/YieldTable";
import RevenueImpressionsChart from "@/components/charts/RevenueImpressionsChart.vue";
import RevenueBySlotsChart from "@/components/charts/RevenueBySlotsChart.vue";
import ImpressionsBySlotsChart from "@/components/charts/ImpressionsBySlotsChart.vue";
// import CpmBySlotsChart from "@/components/charts/CpmBySlotsChart.vue";
import WebsRevenueStackedBarChart from "@/components/charts/WebsRevenueStackedBarChart.vue";
import WebsImpressionsStackedBarChart from "@/components/charts/WebsImpressionsStackedBarChart.vue";
import LaDailyDataForm from "@/components/dialog/DailyDataForm.vue";
import LaDialog from "@/components/dialog/Dialog.vue";
import LaCsvDownload from "@/components/CsvDownload.vue";
import { reportFilenamePrefix, YIELD_PUBLISHER_GETTER } from "@/helpers/reportFilename";
import { buildMultiWebsiteCsvRows } from "@/helpers/yieldCsv";

export default {
    name: "LaYieldDataCard",
    components: {
        LaCsvDownload,
        BaseCard,
        LaDataCardLoader,
        LaYieldTable,
        RevenueImpressionsChart,
        WebsRevenueStackedBarChart,
        WebsImpressionsStackedBarChart,
        LaDialog,
        LaDailyDataForm,
        RevenueBySlotsChart,
        ImpressionsBySlotsChart,
        // CpmBySlotsChart,
    },
    props: {
        yieldLoading: {
            type: Boolean,
        },
        useSlotData: {
            type: Boolean,
            default: false,
        },
        yieldMetadata: {
            type: Object,
            required: true,
        },
        yieldData: {
            type: Array,
            required: true,
        },
        yieldCsvData: {
            type: Array,
            required: true,
        },
        domains: {
            type: Array,
            required: true,
        },
    },
    computed: {
        // Per-website breakdown (as in the stacked charts) with daily and period totals
        multiWebsiteCsvRows() {
            return buildMultiWebsiteCsvRows(this.yieldData);
        },
        filename() {
            // Several websites: name the file after the selected publisher instead of listing every domain
            if (this.domains.length > 1) {
                return `${reportFilenamePrefix(this.domains, YIELD_PUBLISHER_GETTER)}_%from>%to`;
            }
            return `${this.domains[0]}_yield_%from>%to`;
        },
    },
};
</script>
